import { render, staticRenderFns } from "./BusinessRecordCertificate.vue?vue&type=template&id=1eb651b0&scoped=true"
import script from "./BusinessRecordCertificate.vue?vue&type=script&lang=js"
export * from "./BusinessRecordCertificate.vue?vue&type=script&lang=js"
import style0 from "./BusinessRecordCertificate.vue?vue&type=style&index=0&id=1eb651b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb651b0",
  null
  
)

export default component.exports